// extracted by mini-css-extract-plugin
export var brands = "styles-module--brands--f2498";
export var description = "styles-module--description--a6488";
export var logos = "styles-module--logos--6bdb8";